import { Routes, Route, Navigate } from 'react-router-dom'
import { useFlags } from '@equipmentshare/feature-flags'
import MuiRollout from 'components/MuiRollout'
import Parts from './parts'
import ProductClasses from './productClasses'
import Providers from './providers'
import InventoryLocations from './inventoryLocations'
import Permissions from './permissions'
import PartsAlpha from './partsAlpha'
import ItemMasters from './itemMasters'
import ItemMasterDetail from './itemMasters/detail'
import ItemMasterCreate from './itemMasters/create'
import ItemMasterEdit from './itemMasters/edit'
import ItemMasterAddVariant from './itemMasters/addVariant'
import ItemMasterEditVariant from './itemMasters/editVariant'

export default function Management(): JSX.Element {
	const flags = useFlags()
	const itemMasterEnabled = Boolean( flags.costentoryEnableItemMaster )
	return (
		<Routes>
			<Route path="parts" element={<MuiRollout view="parts" eui={<Parts />} mui={<PartsAlpha />} />} />
			<Route path="providers" element={<Providers />} />
			<Route path="product-classes" element={<ProductClasses />} />
			<Route path="stores" element={<InventoryLocations />} />
			<Route path="permissions/*" element={<Permissions />} />
			<Route path="item-masters" element={itemMasterEnabled ? <ItemMasters /> : <Navigate to="/" />} />
			<Route path="item-masters/new" element={itemMasterEnabled ? <ItemMasterCreate /> : <Navigate to="/" />} />
			<Route path="item-masters/:id" element={itemMasterEnabled ? <ItemMasterDetail /> : <Navigate to="/" />} />
			<Route path="item-masters/:id/edit" element={itemMasterEnabled ? <ItemMasterEdit /> : <Navigate to="/" />} />
			<Route path="item-masters/:id/add-variant" element={itemMasterEnabled ? <ItemMasterAddVariant /> : <Navigate to="/" />} />
			<Route path="item-masters/:id/variants/:variantId/edit" element={itemMasterEnabled ? <ItemMasterEditVariant /> : <Navigate to="/" />} />
		</Routes>
	)
}
